import React, { Component } from 'react';

interface Props {
    children?: React.ReactNode;
    fallback?: any;
}

interface State {
    hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
    public static getDerivedStateFromError(error) {
        window.log?.error(`[ErrorBoundary] stack:${error?.stack}`);
        return { hasError: true };
    }

    public constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    public render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback();
            }
            return <div></div>;
        }

        return this.props.children;
    }
}
